// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /profile/get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeProfileGetBody,
  typeProfileGetOutput200,
} from "../../sdk/profile/postProfileGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildProfileGetQueryKey(payload: typeProfileGetBody): string[] {
  const queryKeySegments: string[] = [];

  return ["post:profile:profileGet", "svc:profile-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeProfileGetOutput200,
    unknown,
    typeProfileGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useProfileGet(
  payload: typeProfileGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildProfileGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postProfileGet(payload),
    ...resolvedOptions,
  });
}
